;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import axios from 'axios';

/**
 * "New" log format (2026-05-05): [context] METHOD URL => STATUS ERROR_MESSAGE [issues=ISSUES]
 * Why this exists: in the past we used to log the full Axios error object to stdout.
 *
 * Here, we reduce that API error message to a single line.
 * We still keep the most relevant info for debugging, but avoid out of memoery issues.
 */
export function logApiError(error: unknown, context: string): void {
  if (axios.isAxiosError(error)) {
    const method = error.config?.method?.toUpperCase() ?? '?';
    const url = `${error.config?.baseURL ?? ''}${error.config?.url ?? ''}`;
    const status = error.response?.status ?? 'no-response';
    const issues = error.response?.data?.issues;
    const issuesPart = issues ? ` issues=${JSON.stringify(issues).slice(0, 500)}` : '';
    console.error(`[${context}] ${method} ${url} => ${status} ${error.message}${issuesPart}`);
    return;
  }
  console.error(`[${context}] ${(error as Error)?.message ?? String(error)}`);
}
